<script lang="ts">
    import { messageInfo } from "../store.js";
    import Input from "../components/Input.svelte";
    import Switch from "../components/Switch.svelte";
    import Divider from "../components/Divider.svelte";
    import Photo from "../components/Photo.svelte";
    import Submit from "../components/Submit.svelte";
</script>

<main>
    <Divider>Identification</Divider>
    <Input
        bind:value={$messageInfo.registration}
        helper="Ou numéro de parc selon le cas"
        focus
    >
        Immatriculation
    </Input>
    <Input
        bind:value={$messageInfo.description}
        helper="Préciser modèle du véhicule ou matériel"
    >
        Description
    </Input>
    <Input
        type="number"
        min="0"
        max="10000000"
        bind:value={$messageInfo.counter}
        helper="Kilométrage ou compteur horaire selon le cas"
    >
        Compteur
    </Input>
    <Switch bind:checked={$messageInfo.counterByHour}>
        Compteur en heures
    </Switch>

    <Divider>Photo de l'extérieur du véhicule (3/4 avant)</Divider>

    <Photo bind:data={$messageInfo.photo} />

    <Submit backButton>Valider</Submit>
</main>
